import * as React from "react";
function SvgFemale(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M38.9 24.9L26.6 15c-.3-.6-.9-1.1-1.6-1.3-.2-.1-.4-.1-.6-.1-.9 0-1.7.5-2.2 1.3L9.1 24.8l1.5 2 10.4-8L15.4 38h4v10H22V37.9h5V48h2.5V37.9h3.9L27.9 19l9.4 7.7 1.6-1.8zm-8.8 10.5H18.8l5.6-19.2h.1l.1-.1 5.5 19.3zm-9.4-24.6c1.1.8 2.3 1.3 3.7 1.3h.8c3.3-.4 5.7-3.4 5.3-6.7C30 2 27-.3 23.7 0c-3.3.4-5.7 3.4-5.3 6.7.2 1.6 1.1 3.1 2.3 4.1zM24 2.5c1.9-.2 3.7 1.1 3.9 3 .2 1.9-1.1 3.7-3 3.9-1.9.2-3.7-1.1-3.9-3-.3-1.9 1-3.6 3-3.9z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFemale);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
